var map;
var geocoder;

function initMap() {
	geocoder = new google.maps.Geocoder();

	map = new google.maps.Map(document.getElementById('map'), {
		zoom: 16
	});

	if ($('marker').length == 1) {
		var marker = $('marker');
		var adresse = marker.attr('adresse') + (marker.attr('complement') ? ' ' + marker.attr('complement') : '') + ', ' + marker.attr('codepostal') + ' ' + marker.attr('ville');

		geocoder.geocode({'address': adresse}, function(results, status) {
			if (status == 'OK') {
				map.setCenter(results[0].geometry.location);
				var map_marker = new google.maps.Marker({
					map: map,
					title: marker.attr('nom'),
					position: results[0].geometry.location
				});
			} else {
				console.log('Geocode was not successful for the following reason: ' + status);
			}
		});
	}
}
